import React from "react";

const Error = () => {
  return (
    <div className="text-center p-8 m-auto w-1/2 h-full text-white text-xl md:text-4xl">
      Sorry 😢, Page Not Found
    </div>
  );
};

export default Error;
